<div class="bg-white custom-hv">
  <div class="container">
    <header role="banner">
      <div class="row justify-content-center mt-4">
        <div class="col-lg-12 col-md-12 col-sm-12 d-flex justify-content-center">
          <img id="img_registration_form_edu_logo" src="assets/images/edu-logo.svg" alt="{{genericMessage['G0001']}}"
            class="img-fluid" />
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12">
          <h1 class="sr-only">Educator Registration Form</h1>
        </div>
      </div>
    </header>
    <hr />
    <main role="main">
      <div class="col-lg-12 col-md-12 col-sm-12 mx-auto pb-5">
        <div class="mt-5">
          <h3 id="registration_heading" tabindex="1">Educator Registration</h3>
        </div>
        <div class="mt-4">
          <form [formGroup]="registrationForm" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
                <label for="input_registration_form_first_name">First Name<span
                    class="requiredfield text-danger">*</span></label>
                <input type="text" placeholder="Enter First Name" tabindex="2" id="input_registration_form_first_name"
                  formControlName="firstName" class="Inputs form-control text-capitalize mt-1" maxlength="30"
                  minlength="2" required aria-required="true"
                  [attr.aria-invalid]="registrationForm.get('firstName')?.touched && registrationForm.get('firstName')?.invalid ? 'true' : null"
                  [attr.aria-describedby]="registrationForm.get('firstName')?.touched && registrationForm.get('firstName')?.invalid ? 'firstName-error' : null"
                  (input)="onFirstNameInput($event)" (blur)="checkForTrailingSpace($event, 'firstName')" [ngClass]="{
                  'is-invalid': registrationForm.get('firstName')?.touched && registrationForm.get('firstName')?.invalid
                }" />
                <div *ngIf="
                  registrationForm.get('firstName')?.touched && registrationForm.get('firstName')?.errors as errors
                ">
                  <div id="firstName-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{
                    errorMessage['M0001'] }}</div>
                  <div id="firstName-error"
                    *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                    class="text-danger mt-1 err-font">
                    {{ errorMessage['M0002'] }}
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
                <label for="input_registration_form_middle_name">Middle Name</label>
                <input type="text" id="input_registration_form_middle_name" placeholder="Enter Middle Name" tabindex="3"
                  formControlName="middleName" maxlength="30" minlength="1"
                  class="Inputs form-control text-capitalize mt-1"
                  [attr.aria-invalid]="registrationForm.get('middleName')?.touched && registrationForm.get('middleName')?.invalid ? 'true' : null"
                  [attr.aria-describedby]="registrationForm.get('middleName')?.touched && registrationForm.get('middleName')?.invalid ? 'middleName-error' : null"
                  (input)="onMiddleNameInput($event)" (blur)="checkForTrailingSpace($event, 'middleName')"
                  [ngClass]="{ 'is-invalid': registrationForm.get('middleName')?.invalid }" />
                <div *ngIf="
                  registrationForm.get('middleName')?.touched && registrationForm.get('middleName')?.errors as errors
                ">
                  <div id="middleName-error"
                    *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                    class="text-danger mt-1 err-font">
                    {{ errorMessage['M0003'] }}
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
                <label for="input_registration_form_last_name">Last Name<span
                    class="requiredfield text-danger">*</span></label>
                <input type="text" id="input_registration_form_last_name" placeholder="Enter Last Name" tabindex="4"
                  formControlName="lastName" maxlength="30" minlength="2"
                  class="Inputs form-control text-capitalize mt-1" required aria-required="true"
                  [attr.aria-invalid]="registrationForm.get('lastName')?.touched && registrationForm.get('lastName')?.invalid ? 'true' : null"
                  [attr.aria-describedby]="registrationForm.get('lastName')?.touched && registrationForm.get('lastName')?.invalid ? 'lastName-error' : null"
                  (input)="onLastNameInput($event)" (blur)="checkForTrailingSpace($event, 'lastName')" [ngClass]="{
                  'is-invalid': registrationForm.get('lastName')?.touched && registrationForm.get('lastName')?.invalid
                }" />
                <div
                  *ngIf="registrationForm.get('lastName')?.touched && registrationForm.get('lastName')?.errors as errors">
                  <div id="lastName-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{
                    errorMessage['M0004'] }}</div>
                  <div id="lastName-error"
                    *ngIf="!errors['required'] && (errors['pattern'] || errors['minlength'] || errors['maxlength'])"
                    class="text-danger mt-1 err-font">
                    {{ errorMessage['M0005'] }}
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12 position-relative">
                <label for="input_registration_form_suffix">Suffix</label>
                <div class="dropdown-clear-wrapper mt-1">
                  <select id="input_registration_form_suffix" formControlName="suffix" class="form-control" tabindex="5"
                    [style.color]="registrationForm.get('suffix')?.value === null ? '#757575' : '#010101'"
                    [ngClass]="{'empty-select': registrationForm.get('suffix')?.value === null}">
                    <option hidden disabled selected [ngValue]="null" style="color: #757575 !important;">Select Suffix
                    </option>
                    <option *ngFor="let list of suffixList" [value]="list.key"
                      [attr.aria-label]="getSuffixAriaLabel(list.value)">{{ list.value }}</option>
                  </select>
                  <!-- <button *ngIf="registrationForm.get('suffix')?.value" type="button"
                    id="btn_registration_form_clear_suffix" class="clear-icon" tabindex="5"
                    (click)="registrationForm.get('suffix')?.setValue(null); $event.stopPropagation()"
                    aria-label="Close" title="Close">
                    <span aria-hidden="true">&#10006;</span>
                  </button> -->
                </div>
              </div>
            </div>
            <div class="row mt-lg-3">
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
                <label for="input_registration_form_date_of_birth">Date of Birth<span
                    class="requiredfield text-danger">*</span></label>
                <div class="input-group ssn-input-group">
                  <input type="text" id="input_registration_form_date_of_birth" formControlName="dob"
                    placeholder="Select Date of Birth" data-placeholder="MM/DD/YYYY"
                    class="form-control date-uppercase mt-1" required aria-required="true"
                    [attr.aria-invalid]="registrationForm.get('dob')?.touched && registrationForm.get('dob')?.invalid ? 'true' : null"
                    [attr.aria-describedby]="registrationForm.get('dob')?.touched && registrationForm.get('dob')?.invalid ? 'dob-error' : null"
                    tabindex="6" maxlength="10" (input)="formatDateInput($event)" [ngClass]="{
                    'is-invalid': registrationForm.get('dob')?.touched && registrationForm.get('dob')?.invalid,
                    'has-value': !!registrationForm.get('dob')?.value
                  }" />
                  <span class="ssn-eye mt-1">
                    <button type="button" id="btn_registration_form_open_calendar" class="btn p-0 eye" tabindex="7"
                      (click)="openDatePicker($event)" (keypress)="openDatePicker($event)" title="Open Calendar"
                      aria-label="Open date picker">
                      <span class="material-symbols-outlined f-20 cal">
                        calendar_month
                      </span>
                    </button>
                  </span>
                </div>
                <div *ngIf="registrationForm.get('dob')?.touched && registrationForm.get('dob')?.errors as errors">
                  <div id="dob-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">
                    {{ errorMessage['M0009'] }}
                  </div>
                  <div id="dob-error" *ngIf="errors['ageInvalid']" class="text-danger mt-1 err-font">
                    {{ errorMessage['M0010'] }}
                  </div>
                  <div id="dob-error" *ngIf="errors['futureDate']" class="text-danger mt-1 err-font">
                    {{ errorMessage['M0010'] }}
                  </div>
                </div>
              </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12 position-relative">
                <label for="input_registration_form_gender">Gender<span
                    class="requiredfield text-danger">*</span></label>
                <div class="dropdown-clear-wrapper mt-1">
                  <select #genderField id="input_registration_form_gender" formControlName="gender" class="form-control" required
                    aria-required="true"
                    [attr.aria-invalid]="registrationForm.get('gender')?.touched && registrationForm.get('gender')?.invalid ? 'true' : null"
                    [attr.aria-describedby]="registrationForm.get('gender')?.touched && registrationForm.get('gender')?.invalid ? 'gender-error' : null"
                    tabindex="8" [style.color]="registrationForm.get('gender')?.value === null ? '#757575' : '#010101'"
                    [ngClass]="{
                    'is-invalid': registrationForm.get('gender')?.touched && registrationForm.get('gender')?.invalid,
                    'empty-select': registrationForm.get('gender')?.value === null
                  }">
                    <option hidden disabled selected [ngValue]="null" style="color: #757575 !important;">Select Gender
                    </option>
                    <option *ngFor="let list of genderList" [value]="list.key">{{ list.value }}</option>
                  </select>
                  <!-- X icon, shown only if a value is selected -->
                  <!-- <button *ngIf="registrationForm.get('gender')?.value" type="button"
                    id="btn_registration_form_clear_gender" class="clear-icon" tabindex="9"
                    (click)="registrationForm.get('gender')?.setValue(null); $event.stopPropagation()"
                    aria-label="Close" title="Close">
                    <span aria-hidden="true">&#10006;</span>
                  </button> -->
                  <div class="sr-only" aria-live="polite" aria-atomic="true">
                    {{ genderClearedAnnouncement }}
                  </div>
                </div>
                <div
                  *ngIf="registrationForm.get('gender')?.touched && registrationForm.get('gender')?.errors as errors">
                  <div id="gender-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{
                    errorMessage['M0006'] }}</div>
                </div>
              </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12 position-relative">
                <label for="input_registration_form_race">Race<span class="requiredfield text-danger">*</span></label>
                <div class="dropdown-clear-wrapper mt-1">
                  <select id="input_registration_form_race" formControlName="race" class="form-control" required
                    aria-required="true"
                    [attr.aria-invalid]="registrationForm.get('race')?.touched && registrationForm.get('race')?.invalid ? 'true' : null"
                    [attr.aria-describedby]="registrationForm.get('race')?.touched && registrationForm.get('race')?.invalid ? 'race-error' : null"
                    tabindex="8" [style.color]="registrationForm.get('race')?.value === null ? '#757575' : '#010101'"
                    [ngClass]="{
                    'is-invalid': registrationForm.get('race')?.touched && registrationForm.get('race')?.invalid,
                    'empty-select': registrationForm.get('race')?.value === null
                  }">
                    <option hidden disabled selected [ngValue]="null" style="color: #757575 !important;">Select Race
                    </option>
                    <option *ngFor="let list of raceList" [value]="list.key">{{ list.value }}</option>
                  </select>
                  <!-- <button *ngIf="registrationForm.get('race')?.value" type="button"
                    id="btn_registration_form_clear_race" class="clear-icon" tabindex="11"
                    (click)="registrationForm.get('race')?.setValue(null); $event.stopPropagation()"
                    aria-label="Close" title="Close">
                    <span aria-hidden="true">&#10006;</span>
                  </button> -->
                </div>
                <div *ngIf="registrationForm.get('race')?.touched && registrationForm.get('race')?.errors as errors">
                  <div id="race-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{
                    errorMessage['M0007'] }}</div>
                </div>
              </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12 position-relative">
                <label for="input_registration_form_ethnicity">Ethnicity<span
                    class="requiredfield text-danger">*</span></label>
                <div class="dropdown-clear-wrapper mt-1">
                  <select id="input_registration_form_ethnicity" formControlName="ethnicity" class="form-control"
                    required aria-required="true"
                    [attr.aria-invalid]="registrationForm.get('ethnicity')?.touched && registrationForm.get('ethnicity')?.invalid ? 'true' : null"
                    [attr.aria-describedby]="registrationForm.get('ethnicity')?.touched && registrationForm.get('ethnicity')?.invalid ? 'ethnicity-error' : null"
                    tabindex="9"
                    [style.color]="registrationForm.get('ethnicity')?.value === null ? '#757575' : '#010101'" [ngClass]="{
                    'is-invalid':
                      registrationForm.get('ethnicity')?.touched && registrationForm.get('ethnicity')?.invalid,
                    'empty-select': registrationForm.get('ethnicity')?.value === null
                  }">
                    <option hidden disabled selected [ngValue]="null" style="color: #757575 !important;">Select
                      Ethnicity
                    </option>
                    <option *ngFor="let list of ethnicityList" [value]="list.key">{{ list.value }}</option>
                  </select>
                  <!-- <button *ngIf="registrationForm.get('ethnicity')?.value" type="button"
                    id="btn_registration_form_clear_ethnicity" class="clear-icon" tabindex="13"
                    (click)="registrationForm.get('ethnicity')?.setValue(null); $event.stopPropagation()"
                    aria-label="Close" title="Close">
                    <span aria-hidden="true">&#10006;</span>
                  </button> -->
                </div>
                <div *ngIf="
                  registrationForm.get('ethnicity')?.touched && registrationForm.get('ethnicity')?.errors as errors
                ">
                  <div id="ethnicity-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{
                    errorMessage['M0008'] }}</div>
                </div>
              </div>
            </div>
            <div class="row mt-lg-3">
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
                <div class="d-flex ssn-tooltip-parent" style="position:relative;">
                  <label for="input_registration_form_ssn">
                    SSN / ITIN<span class="requiredfield text-danger">*</span>
                  
                    <span class="tooltip-container" (mouseenter)="openTooltip()" (mouseleave)="closeTooltip()">
                  
                      <!-- Accessible Info button -->
                      <button type="button" class="ml-1 tooltip-icon" tabindex="12" aria-label="info"
                        [attr.aria-describedby]="showSSNTooltip ? 'ssnTooltipContent' : null" [attr.aria-expanded]="showSSNTooltip"
                        (click)="toggleTooltip($event)" (keydown)="onInfoKeydown($event)" title="More info about SSN/ITIN">
                        <span class="material-symbols-outlined f-16" aria-hidden="true">info</span>
                        <span class="sr-only">info</span>
                      </button>
                  
                  
                      <!-- Live Screen reader announcement : Soham Das-->
                      <div class="sr-only" aria-live="polite" aria-atomic="true">
                        {{ tooltipAnnouncement }}
                      </div>
                  
                      <!-- Tooltip for decoration : Soham Das -->
                      <div *ngIf="showSSNTooltip" id="ssnTooltip" class="ssn-tooltip-box" role="tooltip">
                        <div class="ssn-tooltip-polygon" aria-hidden="true"></div>
                        <div id="ssnTooltipContent" class="ssn-tooltip-frame" (click)="$event.stopPropagation()"
                          (keypress)="$event.stopPropagation()">
                          {{ genericMessage['G0003'] }}
                        </div>
                      </div>
                  
                      <!-- Optional visual arrow : Soham Das -->
                      <span *ngIf="showSSNTooltip" class="material-symbols-outlined inverted-arrow"
                        style="position:absolute; top:-16px; left:50%; transform:translateX(-50%);" aria-hidden="true">
                        arrow_drop_down
                      </span>
                    </span>
                  </label>

                  <!-- Live regions added by Soham for detection of msg -->
                  <span class="ml-auto ssn-sign" aria-live="polite">
                    <ng-container *ngIf="SSNDetected">
                      {{ genericMessage['G0013'] }}
                    </ng-container>
                    <ng-container *ngIf="ITINDetected && !SSNDetected">
                      {{ genericMessage['G0014'] }}
                    </ng-container>
                  </span>
                </div>
                <div class="input-group ssn-input-group">
                  <input type="text" id="input_registration_form_ssn" [value]="displayedSSN"
                    class="form-control ssn-input" required aria-required="true"
                    [attr.aria-invalid]="(registrationForm.get('ssn')?.touched && registrationForm.get('ssn')?.invalid) || ssnExists ? 'true' : null"
                    [attr.aria-describedby]="(registrationForm.get('ssn')?.touched && registrationForm.get('ssn')?.invalid) || ssnExists ? 'ssn-error' : null"
                    formControlName="ssn" tabindex="10" placeholder="Enter SSN or ITIN" maxlength="11"
                    (input)="onSSNInput($event)" (focus)="isSSNFocused=true; onSSNFocus()"
                    (blur)="isSSNFocused=false; onSSNBlur()" autocomplete="off" numbersOnly [ngClass]="{
                    'is-invalid': (registrationForm.get('ssn')?.touched && registrationForm.get('ssn')?.invalid) || (ssnExists && !isSSNFocused)
                  }" />
                  <span class="ssn-eye">
                    <button type="button" class="btn p-0 eye pi pi-eye" tabindex="11"
                      [ngClass]="{ 'pi-eye': showSSN, 'pi-eye-slash': !showSSN }" (click)="toggleSSN($event)"
                      (keypress)="toggleSSN($event)" title="{{ showSSN ? 'Hide SSN/ITIN' : 'Show SSN/ITIN' }}"
                      aria-label="Show/hide SSN/ITIN" id="btn_registration_form_toggle_ssn"></button>
                  </span>
                </div>
                <!-- Form validation errors -->
                <div *ngIf="registrationForm.get('ssn')?.touched && registrationForm.get('ssn')?.errors as errors">
                  <div id="ssn-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{
                    errorMessage['M0011'] }}</div>
                  <div id="ssn-error" *ngIf="!errors['required'] && errors['pattern']"
                    class="text-danger mt-1 err-font">
                    <ng-container *ngIf="idTypeDetected === 'SSN'">
                      {{ errorMessage['M0012'] }}
                    </ng-container>
                    <ng-container *ngIf="idTypeDetected === 'ITIN'">
                      {{ errorMessage['M0040'] }}
                    </ng-container>
                    <ng-container *ngIf="!idTypeDetected">
                      Please enter a valid SSN or ITIN number.
                    </ng-container>
                  </div>
                  <div id="ssn-error" *ngIf="!errors['required'] && !errors['pattern'] && errors['ssnInvalid']"
                    class="text-danger mt-1 err-font">
                    {{ errorMessage['M0013'] }}
                  </div>
                </div>
                <!-- Server-side validation error -->
                <div id="ssn-error" *ngIf="ssnExists" class="text-danger mt-1 err-font">
                  <ng-container *ngIf="idTypeDetected === 'SSN'">
                    The SSN entered is already on file.
                  </ng-container>
                  <ng-container *ngIf="idTypeDetected === 'ITIN'">
                    The ITIN entered is already on file.
                  </ng-container>
                </div>
              </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
                <div class="d-flex" style="position:relative;">
                  <label for="input_registration_form_email">Email<span class="requiredfield text-danger">*</span>

                    <span class="tooltip-container" (mouseenter)="openEmailTooltip()" (mouseleave)="closeEmailTooltip()">
                
                      <!-- Accessible Info button -->
                      <button type="button" class="ml-1 tooltip-icon" aria-label="info" tabindex="14"
                        [attr.aria-describedby]="emailTooltip ? 'emailTooltipContent' : null" [attr.aria-expanded]="emailTooltip"
                        (click)="toggleEmailTooltip($event)" (keydown)="onEmailInfoKeydown($event)" title="Info on Email">
                        <span class="material-symbols-outlined f-16" aria-hidden="true">info</span>
                        <span class="sr-only">info</span>
                      </button>
                
                      <!-- Screen reader announcement live region -->
                      <div class="sr-only" aria-live="polite" aria-atomic="true">
                        {{ emailTooltipAnnouncement }}
                      </div>
                
                      <!-- Tooltip -->
                      <div *ngIf="emailTooltip" id="emailTooltip" class="email-tooltip-box" role="tooltip">
                        <div class="ssn-tooltip-polygon" aria-hidden="true"></div>
                        <div id="emailTooltipContent" class="email-tooltip-frame" (click)="$event.stopPropagation()"
                          (keypress)="$event.stopPropagation()">
                          {{ genericMessage['G0002'] }}
                        </div>
                      </div>
                
                      <!-- Optional visual arrow (decorative) -->
                      <span *ngIf="emailTooltip" class="material-symbols-outlined inverted-arrow"
                        style="position:absolute; top:-16px; left:50%; transform:translateX(-50%);" aria-hidden="true">
                        arrow_drop_down
                      </span>
                    </span>
                  </label>                  
                </div>
                <input type="email" id="input_registration_form_email" formControlName="email" class="form-control"
                  required aria-required="true"
                  [attr.aria-invalid]="(registrationForm.get('email')?.touched && registrationForm.get('email')?.invalid) || emailExists ? 'true' : null"
                  [attr.aria-describedby]="(registrationForm.get('email')?.touched && registrationForm.get('email')?.invalid) || emailExists ? 'email-error' : null"
                  placeholder="user@example.com" tabindex="13" maxlength="255" (focus)="isEmailFocused = true"
                  (blur)="isEmailFocused = false; checkEmail();" [ngClass]="{
                  'is-invalid': (registrationForm.get('email')?.touched && registrationForm.get('email')?.invalid) || (emailExists && !isEmailFocused)
                }" />
                <!-- Form validation errors -->
                <div *ngIf="registrationForm.get('email')?.touched && registrationForm.get('email')?.errors as errors">
                  <div id="email-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{
                    errorMessage['M0014'] }}</div>
                  <div id="email-error" *ngIf="!errors['required'] && errors['pattern']"
                    class="text-danger mt-1 err-font">
                    {{ errorMessage['M0015'] }}
                  </div>
                </div>
                <!-- Server-side validation error -->
                <div id="email-error" *ngIf="emailExists" class="text-danger mt-1 err-font">
                  The email entered is already on file.
                </div>
              </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
                <div class="d-flex" style="position:relative;">
                  <label for="input_registration_form_recovery_email">Recovery Email

                    <!-- Accessible Info button with tooltip container -->
                    <span class="tooltip-container" (mouseenter)="openRecoveryEmailTooltip()" (mouseleave)="closeRecoveryEmailTooltip()">
                      <button type="button" class="ml-1 tooltip-icon" aria-label="info" tabindex="16"
                        [attr.aria-describedby]="recoveryEmailTooltip ? 'recoveryEmailTooltipContent' : null"
                        [attr.aria-expanded]="recoveryEmailTooltip" (click)="toggleRecoveryEmailTooltip($event)"
                        (keydown)="onRecoveryEmailInfoKeydown($event)" title="Info on Recovery Email">
                        <span class="material-symbols-outlined f-16" aria-hidden="true">info</span>
                        <span class="sr-only">info</span>
                      </button>

                      <!-- Tooltip -->
                      <div *ngIf="recoveryEmailTooltip" id="recoveryEmailTooltip" class="email-tooltip-box"
                        role="tooltip">
                        <div class="ssn-tooltip-polygon" aria-hidden="true"></div>
                        <div id="recoveryEmailTooltipContent" class="email-tooltip-frame"
                          (click)="$event.stopPropagation()" (keypress)="$event.stopPropagation()">
                          {{ genericMessage['G0002'] }}
                        </div>
                      </div>

                      <!-- Optional visual arrow (decorative) -->
                      <span *ngIf="recoveryEmailTooltip" class="material-symbols-outlined inverted-arrow"
                        style="position:absolute; top:-16px; left:50%; transform:translateX(-50%);" aria-hidden="true">
                        arrow_drop_down
                      </span>
                    </span>
                  </label>

                  <!-- Screen reader announcement live region - Only announces tooltip content -->
                  <div class="sr-only" aria-live="polite" aria-atomic="true">
                    {{ recoveryEmailTooltipAnnouncement }}
                  </div>
                </div>
                <input type="email" id="input_registration_form_recovery_email" formControlName="recovery_email"
                  tabindex="15" class="form-control"
                  [attr.aria-invalid]="(registrationForm.get('recovery_email')?.touched && registrationForm.get('recovery_email')?.invalid && registrationForm.get('recovery_email')?.value) || recoveryEmailExists ? 'true' : null"
                  [attr.aria-describedby]="(registrationForm.get('recovery_email')?.touched && registrationForm.get('recovery_email')?.invalid && registrationForm.get('recovery_email')?.value) || recoveryEmailExists ? 'recoveryEmail-error' : null"
                  placeholder="user@example.com" maxlength="255" (focus)="isRecoveryEmailFocused = true"
                  (blur)="isRecoveryEmailFocused = false; checkRecoveryEmail()" [ngClass]="{
                  'is-invalid': 
                    (registrationForm.get('recovery_email')?.touched &&
                    registrationForm.get('recovery_email')?.invalid &&
                    registrationForm.get('recovery_email')?.value) || (recoveryEmailExists && !isRecoveryEmailFocused)
                }" />
                <!-- Form validation errors -->
                <div
                  *ngIf="registrationForm.get('recovery_email')?.touched && registrationForm.get('recovery_email')?.errors as errors">
                  <div id="recoveryEmail-error" *ngIf="!errors['required'] && errors['pattern']"
                    class="text-danger mt-1 err-font">
                    {{ errorMessage['M0015'] }}
                  </div>
                  <div id="recoveryEmail-error" *ngIf="errors['sameAsEmail']" class="text-danger mt-1 err-font">
                    Primary and recovery emails must be different.
                  </div>
                </div>
                <!-- Server-side validation error -->
                <div id="recoveryEmail-error"
                  *ngIf="recoveryEmailExists && !registrationForm.get('recovery_email')?.errors?.['sameAsEmail']"
                  class="text-danger mt-1 err-font">
                  The recovery email entered is already on file.
                </div>
              </div>
              <div class="form-group col-lg-3 col-md-6 col-sm-12">
                <label for="input_registration_form_phone_number">Phone Number<span
                    class="requiredfield text-danger">*</span></label>
                <input type="text" id="input_registration_form_phone_number" formControlName="phoneNumber"
                  class="form-control" required aria-required="true"
                  [attr.aria-invalid]="(registrationForm.get('phoneNumber')?.touched && registrationForm.get('phoneNumber')?.invalid) || phoneExists ? 'true' : null"
                  [attr.aria-describedby]="(registrationForm.get('phoneNumber')?.touched && registrationForm.get('phoneNumber')?.invalid) || phoneExists ? 'phoneNumber-error' : null"
                  placeholder="Enter Phone Number" tabindex="17" (input)="formatPhoneNumber($event)"
                  (focus)="isPhoneFocused = true" (blur)="isPhoneFocused = false; checkPhone()" numbersOnly [ngClass]="{
                  'is-invalid':
                    (registrationForm.get('phoneNumber')?.touched && registrationForm.get('phoneNumber')?.invalid) || (phoneExists && !isPhoneFocused)
                }" />
                <!-- Form validation errors -->
                <div
                  *ngIf="registrationForm.get('phoneNumber')?.touched && registrationForm.get('phoneNumber')?.errors as errors">
                  <div id="phoneNumber-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{
                    errorMessage['M0016'] }}</div>
                  <div id="phoneNumber-error" *ngIf="!errors['required'] && (errors['pattern'] || errors['allZeros'])"
                    class="text-danger mt-1 err-font">
                    {{ errorMessage['M0017'] }}
                  </div>
                </div>
                <!-- Server-side validation error -->
                <div id="phoneNumber-error" *ngIf="phoneExists" class="text-danger mt-1 err-font">
                  The phone number entered is already on file.
                </div>
              </div>
            </div>
            <div class="row mt-lg-3">
              <div class="form-group">
                <div class="form-check mb-0 pb-0">
                  <input type="checkbox" id="input_registration_form_terms" formControlName="terms"
                    class="mb-2 mr-3 check-box" required aria-required="true"
                    [attr.aria-describedby]="registrationForm.get('terms')?.touched && registrationForm.get('terms')?.invalid ? 'terms-error' : null"
                    tabindex="18" />
                  <label for="input_registration_form_terms" class="form-check-label mb-0"
                    (click)="$event.preventDefault()" (keypress)="$event.preventDefault()" aria-live="polite" aria-atomic="true">
                    I have read and agree to the
                    <a href="javascript:void(0)" tabindex="19" class="link-pointer"
                      (click)="openTermsAndConditionsModal($event)"><u>User Agreement.</u></a>
                    <!-- <a href="javascript:void(0)" tabindex="19" class="link-pointer"
                      (click)="openPrivacyPolicyModal($event)">Privacy Policy</a>. -->
                    <span class="requiredfield text-danger">*</span>
                  </label>

                </div>
                <div *ngIf="registrationForm.get('terms')?.touched && registrationForm.get('terms')?.errors as errors"
                  class="form-check mt-0">
                  <div id="terms-error" *ngIf="errors['required']" class="text-danger mt-1 err-font" aria-live="polite" aria-atomic="true">{{
                    errorMessage['M0044'] }}</div>
                </div>
                <div class="form-check mt-2 mr-3 mb-0 pb-0">
                  <input type="checkbox" id="input_registration_form_consent" formControlName="consent"
                    class="check-box mb-4 mr-3" required aria-required="true" tabindex="20"
                    [attr.aria-describedby]="registrationForm.get('consent')?.touched && registrationForm.get('consent')?.invalid ? 'consent-error' : null" />
                  <label for="input_registration_form_consent" class="form-check-label mb-0"
                    (click)="$event.preventDefault()" (keypress)="$event.preventDefault()" aria-live="polite" aria-atomic="true">
                    I consent to receive emails and SMS messages from the Nevada Department of Education Online Portal
                    for
                    Application and Licensure for account verification and official communications.
                    <span class="requiredfield text-danger">*</span>
                  </label>

                </div>
                <div
                  *ngIf="registrationForm.get('consent')?.touched && registrationForm.get('consent')?.errors as errors"
                  class="form-check mt-0">
                  <div id="consent-error" *ngIf="errors['required']" class="text-danger mt-1 err-font">{{
                    errorMessage['M0044'] }}</div>
                </div>
              </div>

            </div>
            <hr />
            <div class="row justify-content-end pb-3 mt-2 mr-0 mb-5">
              <div class="d-flex">
                <button type="button" id="btn_registration_form_return_to_login" class="btn btn-outline-secondary"
                  (click)="goToLogin()" tabindex="21">Return to Login</button>
                <button type="submit" id="btn_registration_form_continue" class="btn btn-primary" tabindex="22"
                  aria-label="Continue to next step" aria-live="polite"
                  [disabled]="registrationForm.invalid || ssnExists || emailExists || phoneExists || recoveryEmailExists"
                  [attr.aria-disabled]="registrationForm.invalid || ssnExists || emailExists || phoneExists || recoveryEmailExists ? 'true' : null"
                  [attr.aria-label]="registrationForm.invalid || ssnExists || emailExists || phoneExists || recoveryEmailExists ? 'Continue button is disabled. Please fill in all required fields correctly to continue.' : 'Continue to next step'">
                  Continue
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </main>
    <div
      *ngIf="SSNError || (emailError && !recoveryEmailError && !phoneError) || (phoneError && !emailError && !recoveryEmailError) || (!emailError && recoveryEmailError && !phoneError) || (SSNError && !phoneError && !emailError && !recoveryEmailError)"
      class="toast-message " role="status" aria-live="polite" aria-atomic="true">
      <div class="d-flex">
        <p class="text-white mb-0" role="alert">
          {{currentToastMessage}}
        </p>
        <span class="material-symbols-outlined f-24 mt-3" style="cursor: pointer;" (click)="closeErrorToast()"
          title="Close">close</span>
      </div>
    </div>
    <div *ngIf="emailSentMessage" class="toast-message-1" role="status" aria-live="polite" aria-atomic="true">
      <span class="material-symbols-outlined mb-4 pr-2 f-24" style="cursor: pointer;" (click)="closeSuccessToast()"
        title="Close">check</span>
      <div>
        <p class="text-white mb-0 fw-6">Your information has been sent to our support team</p>
        <p class="text-white mb-0 fw-4">
          A confirmation email has been sent to {{ this.registrationForm.get('email')?.value }}
        </p>
      </div>
    </div>
  </div>
  <ng-template #content let-modal>
    <div class="modal-content">
      <div class="d-flex text-black modal-header pl-4 pr-4 mt-3">
        <h5 class="font-18">Terms &amp; conditions</h5>
        <button type="button" id="btn_registration_form_modal_close" class="btn p-0" aria-label="Close"
          (click)="modal.dismiss('Cross click')">
          <span class="material-symbols-outlined"> close </span>
        </button>
      </div>

      <div class="modal-body termscondition"></div>
    </div>
  </ng-template>
</div>